import api from "../../../service/api";
import ActionTypes from "../../actionTypes";
import API_BOOK from "../../../service/endpoints";
import { errorToast } from '../../../utils/toasts';

const { GET_SUMMARY_SUCCESS, GET_SUMMARY_FAIL, GET_DETAILS_SUCCESS, GET_DETAILS_FAIL } = ActionTypes.REPORTS.CAN_PACKET_HEALTH;
const { GET_SUMMARY, GET_DETAILS, EXPORT } = API_BOOK.REPORTS.CAN_PACKET_HEALTH;

/* Action dispatchers */

const getSummarySuccessAD = (payload) => ({
  type: GET_SUMMARY_SUCCESS,
  payload,
});

const getSummaryFailAD = () => ({
  type: GET_SUMMARY_FAIL
});

const getDetailsSuccessAD = (payload) => ({
  type: GET_DETAILS_SUCCESS,
  payload,
});

const getDetailsFailAD = () => ({
  type: GET_DETAILS_FAIL
});

/* Actions */

export const GetCanPacketHealthSummary = ({ startDate, endDate, city, oemAndModels, pageSize, pageIndex }) => async (dispatch) => {
  try {
    const resp = await api({
      method: GET_SUMMARY.method,
      url: GET_SUMMARY.url,
      data: { startDate, endDate, city, oemAndModels, pageSize, pageIndex }
    });
    if (resp.status === 200 && resp?.data?.data) {
      dispatch(getSummarySuccessAD(resp.data.data));
    } else {
      dispatch(getSummaryFailAD());
      errorToast('Failed to fetch CAN packet health summary');
    }
  } catch (error) {
    dispatch(getSummaryFailAD());
    errorToast('Failed to fetch CAN packet health summary');
  }
};

export const GetCanPacketHealthDetails = ({ registrationNumber, startDate, endDate }) => async (dispatch) => {
  try {
    const resp = await api({
      method: GET_DETAILS.method,
      url: GET_DETAILS.url,
      data: { registrationNumber, startDate, endDate }
    });
    if (resp.status === 200 && resp?.data?.data) {
      dispatch(getDetailsSuccessAD(resp.data.data));
    } else {
      dispatch(getDetailsFailAD());
      errorToast('Failed to fetch CAN packet health details');
    }
  } catch (error) {
    dispatch(getDetailsFailAD());
    errorToast('Failed to fetch CAN packet health details');
  }
};

export const ExportCanPacketHealth = ({ startDate, endDate }) => async () => {
  try {
    const resp = await api({
      method: EXPORT.method,
      url: EXPORT.url,
      data: { startDate, endDate },
      responseType: 'blob'
    });
    if (resp.status === 200 && resp.data) {
      // Check if response is JSON (cache generating) instead of Excel blob
      const contentType = resp.headers?.['content-type'] || '';
      if (contentType.includes('application/json')) {
        const text = await resp.data.text();
        const json = JSON.parse(text);
        if (json?.data?.generating) {
          return { generating: true, message: json.message };
        }
        errorToast(json.message || 'No data found for this date');
        return null;
      }

      const blob = new Blob([resp.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const [sy, sm, sd] = startDate.split('-').map(Number);
      const [ey, em, ed] = endDate.split('-').map(Number);
      link.href = url;
      link.download = `CAN_Packet_Health_${sd}${months[sm - 1]}${sy}_to_${ed}${months[em - 1]}${ey}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return { success: true };
    } else {
      errorToast('Failed to export CAN packet health report');
      return null;
    }
  } catch (error) {
    errorToast('Failed to export CAN packet health report');
    return null;
  }
};
